<div class="content-note">
  <div #noteContainer [innerHTML]="data | rmsSafeHtml" class="text-content-wrapper pt-4 pb-2 pl-xl-3" [ngStyle]="containerStyle" (click)="onContentClick($event)" (keydown.enter)="onContentClick($event)"></div>
  <button *ngIf="displayShowMore" type="button" class="btn btn-default btn-outline-teal" [ngClass]="showMore ? 'show-less-btn' : 'show-more-btn'" (click)="onShowMore()">
    <i class="fa" [ngClass]="showMore ? 'fa-angle-up' : 'fa-angle-down'"></i>
    {{showMore ? 'Show Less' : 'Show More'}}
  </button>
</div>
